<template>
  <div class="header-top-area header-top-two dark-bg">
    <div class="container">
      <div class="row">
        <div class="col-xl-3 col-lg-3">
          <div class="header-info">
            <i class="las la-phone"></i>
            <p><span>Hotline</span>: +971 54 566 8994</p>
          </div>
        </div>
        <div class="col-xl-6 col-lg-5 text-center">
          <div class="header-top-link">
            <p>
              Your Partner in Compliance & Financial Growth
              <router-link :to="{ name: 'Contact' }">Get Started</router-link>
            </p>
          </div>
        </div>

        <div class="col-xl-3 col-lg-4 text-end">
          <div class="header-top-right d-flex">
            <div class="header-info">
              <i class="las la-envelope"></i>
              <p>sales@afinotax.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Header Area -->

  <div class="header-area header-two">
    <div class="sticky-area">
      <div class="navigation">
        <div class="container">
          <div class="header-inner-box">
            <div class="logo">
              <router-link :to="{ name: 'Home2' }" class="navbar-brand"
                ><img src="/assets/img/logo.jpeg" alt=""
              /></router-link>
            </div>

            <div class="main-menu">
              <nav class="navbar navbar-expand-lg">
                <button
                  class="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span class="navbar-toggler-icon"></span>
                  <span class="navbar-toggler-icon"></span>
                  <span class="navbar-toggler-icon"></span>
                </button>

                <div
                  class="collapse navbar-collapse justify-content-center"
                  id="navbarSupportedContent"
                >
                  <ul class="navbar-nav m-auto">
                    <li class="nav-item">
                      <router-link class="nav-link active" :to="{ name: 'Home2' }"
                        >Home</router-link
                      >
                    </li>
                    <li class="nav-item">
                      <router-link class="nav-link" :to="{ name: 'About' }"
                        >About Us</router-link
                      >
                    </li>
                    <li class="nav-item">
                      <router-link class="nav-link" :to="{ name: 'Services' }"
                        >Services</router-link
                      >
                    </li>
                    <li class="nav-item">
                      <router-link class="nav-link" :to="{ name: 'FAQ' }"
                        >FAQ</router-link
                      >
                    </li>
                    <li class="nav-item">
                      <router-link class="nav-link" :to="{ name: 'Contact' }"
                        >Contact</router-link
                      >
                    </li>
                  </ul>
                </div>
              </nav>
            </div>

            <a href="https://wa.me/971545668994" target="_blank" rel="noopener noreferrer" class="header-contact" style="text-decoration: none; color: inherit;">
              <div class="header-contact-icon">
                <i class="las la-comments"></i>
              </div>
              <div class="header-contact-info">
                <p>Let's Chat</p>
                <h6>+971 54 566 8994</h6>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Navbar2",
  mounted() {
    //Header Search Form
    if ($(".search-trigger").length) {
      $(".search-trigger").on("click", function () {
        $("body").addClass("search-active");
      });
      $(".close-search, .search-back-drop").on("click", function () {
        $("body").removeClass("search-active");
      });
    }

    // Mobile Menu

    $(".navbar-toggler").on("click", function () {
      $(this).toggleClass("active");
    });

    $(".navbar-nav li a").on("click", function () {
      $(".sub-nav-toggler").removeClass("active");
    });

    var subMenu = $(".navbar-nav .sub-menu");

    if (subMenu.length) {
      subMenu
        .parent("li")
        .children("a")
        .append(function () {
          return '<button class="sub-nav-toggler"> <i class="las la-angle-down"></i> </button>';
        });

      var subMenuToggler = $(".navbar-nav .sub-nav-toggler");

      subMenuToggler.on("click", function () {
        $(this).parent().parent().children(".sub-menu").slideToggle();
        return false;
      });
    }

    //jQuery Sticky Area
    $(".sticky-area").sticky({
      topSpacing: 0,
    });

    // Nice select
    $("select").niceSelect();

    // Active & Remove Class

    $(".sub-menu ul li").on("click", function () {
      $(".sub-menu").removeAttribute("style");
      $(this).addClass("active");
    });

    $("a.nav-link").on("mouseover", function () {
      $("a.nav-link").removeClass("active");
      $(this).addClass("active");
    });
  },
};
</script>

<style scoped>
.logo img {
  width: 255px;
  height: 60px;
  object-fit: contain;
  display: block;
}
</style>